<template>
  <div class="home-wrapper">
    <TopBar />
    <TopMenu />
    <div class="home-center-content">
      <NoAuthority v-if="$store.state.noAuthority" />
      <ServerError v-else-if="$store.state.serverError" />
      <router-view v-else></router-view>
      <slot name="error-page"></slot>
    </div>
    <BottomBar />
    <div v-if="showFlag" class="reversion-box">
      前端版本信息：{{ versionMsg }} &nbsp;&nbsp;&nbsp;&nbsp;后端版本信息：{{ reVersion }}
    </div>
    <!-- 固定在右下角的快捷操作 -->
    <div class="fixed-btns" @click.stop>
      <div class="fixed-btn-item" @click="_purchase" v-if="productType !== 3">
        <i class="iconfont icongoumai"></i>
        <span class="btn-hover">立即购买</span>
      </div>
      <el-popover
        placement="left"
        title="客服电话"
        width="170"
        trigger="hover"
        :open-delay="200"
        :close-delay="100"
        class="fixed-btn-popover"
        popper-class="self-popover-1"
        content="010-53325435">
        <div class="fixed-btn-item" slot="reference">
          <i class="iconfont iconkefudianhua"></i>
          <span class="btn-hover">客服电话</span>
        </div>
      </el-popover>
      <el-popover
        placement="left-start"
        title=""
        width="170"
        trigger="hover"
        :open-delay="200"
        :close-delay="100"
        class="fixed-btn-popover"
        popper-class="self-popover-2"
        content="">
        <div class="fixed-btn-item" slot="reference">
          <i class="iconfont iconxiaochengxu1"></i>
          <span class="btn-hover">小程序码</span>
        </div>
        <div class="self-popover-2-content">
          <img src="../../assets/wx-mini.png" alt="" class="wx-mini-img">
          <p>微信扫一扫</p>
        </div>
      </el-popover>
      <div class="fixed-btn-item last-item" :class="backToTop ? 'last-item-show' : ''">
        <i class="iconfont iconhuidaodingbu"></i>
        <span class="btn-hover" @click="_backToTop">返回顶部</span>
      </div>
      
    </div>
  </div>
</template>

<script>
import { productType } from "config/config";
// @ is an alias to /src
import TopBar from "components/basic-components/top-bar";
import TopMenu from "components/basic-components/top-menu";
import BottomBar from "components/basic-components/bottom-bar";
import NoAuthority from "components/errorPage/403.vue";
import ServerError from "components/errorPage/500.vue";
import store from "store";
// 接口
import { requestGetVersionData } from "api/version";
import { GetDefaultSubjects } from 'api/common';
import { versionMessage } from "config/config";
import { localStorageUtil, debounce } from "utils/util";

export default {
  name: "Home",
  components: {
    TopBar,
    TopMenu,
    BottomBar,
    NoAuthority,
    ServerError
  },
  inject: ['reload'],
  data() {
    return {
      productType: 1,
      showFlag: false,
      versionMsg: versionMessage,
      reVersion: "",
      backToTop: false,
    }
  },
  watch: {
    $route(val) {
      if(val.query.reload && !localStorageUtil.getItem('isReload')) {
        localStorageUtil.setItem('isReload', true);
        localStorageUtil.removeItem('isLogin');
        // console.log('?????', val.query.reload, localStorageUtil.getItem('isReload'));
        this.reload();
      }else if(localStorageUtil.getItem('isReload')){
        localStorageUtil.removeItem('isReload')
      }
    }
  },
  methods: {

    /**
     * 判断版本信息的显示网址
     */
    _checkHost: function(params) {
      this.showFlag = location.host.indexOf("net") !== -1;
      this._getRevisionData();
    },

    /**
     * 获取后端版本信息
     */
    _getRevisionData: function() {
      if(localStorage.getItem('viewshare_version') === 'undefined') {
        localStorage.removeItem('viewshare_version');
      }
      let _v = localStorageUtil.getItem('viewshare_version');
      return requestGetVersionData().then(response => {
        if(Object.prototype.toString.call(response) !== "[object Object]") {
          return;
        }
        localStorageUtil.setItem('viewshare_version', response);
        this.reVersion = response.version;
        if(!_v || _v.settingVersion !== response.settingVersion) {
          GetDefaultSubjects(1);
          GetDefaultSubjects(2);
        }else if(!localStorageUtil.getItem('get_t')) {
          GetDefaultSubjects(2);
        }
      }).catch(err => {
        console.log('err',err);
      });
    },

    /**
     * 立即购买
     * **/
    _purchase() {
      let routeUrl = this.$router.resolve({
        path: "/purchase/product-details",
        query: {
          productId: 1
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    /**
     * 回到顶部
     * **/
    _backToTop() {
      this.$nextTick(() => {
        $('#app').animate({scrollTop: 0});
      });
    },
    
    /**
     * 监听scroll事件
     * **/
    _handleWinScroll(e) {
      this.$nextTick(() => {
        if($('#app').scrollTop() > 100) {
          this.backToTop = true;
        }else {
          this.backToTop = false;
        }
      });
    },
    _handleWinStorage(e) {
      if(e.key === 'accountInfo') {
        let _new = JSON.parse(e.newValue);
        let _old = JSON.parse(e.oldValue);
        if(_new && _old && _new.status !== _old.status) {
          console.log('accountInfo---status', _new.status, _old.status);
          this.reload('accountInfoChange');
        }
      }else if(e.key === 'isLogin' && e.oldValue !== e.newValue) {
        this._loginStorage(e);
      }
    },
    _loginStorage: debounce(function(e) {
      let _path = this.$route.path;
      console.log('storage--change');
      if(_path !== '/home-page' && _path.indexOf('/purchase/') === -1) {
        this.$router.replace('/home-page');
        this.reload();
      }else {
        this.reload();
      }
      
    }, 100, false)
  },
  created() {
    if (isNaN(productType)) {
      this.productType = 1;
    } else {
      this.productType = Number(productType);
    }
    if(localStorageUtil.getItem('isLogin') && !store.state.accountInfo) {
      store.dispatch('getUserInfo');
    }
    this._checkHost();
  },
  mounted() {
    window.addEventListener("storage", this._handleWinStorage);
    this.$nextTick(() => {
      document.querySelector('#app').addEventListener("scroll", this._handleWinScroll);
    });
  },
  destroyed() {
    window.removeEventListener('storage', this._handleWinStorage);
    document.querySelector('#app').removeEventListener('scroll', this._handleWinScroll);
  },
};
</script>
<style lang="less">
@color-main: #03B2B2;
.home-wrapper {
  width: 100%;
  background: #EBF7F7;
  // height: 100%;
  // min-height: 100vh;
  // overflow-y: scroll;
  .home-center-content {
    min-height: calc(100vh - 28px - 62px - 50px);
  }
  .reversion-box {
    position: fixed;
    bottom: 0;
    left: 0;
    color: #000;
    margin-left: 20px;
    z-index: 999;
    white-space: nowrap;
    height: 20px;
    line-height: 20px;

  }
  .main-content-wrapper {
    padding: 20px 0;
    .one-page-wrapper {
      min-height: calc(100vh - 180px);
      padding-bottom: 20px;
      text-align: center;
      background-color: #DFF4F4;
      background-image: url('../../assets/one-page-bg.png');
      background-repeat: no-repeat;
      background-position: 6px bottom;
      border-radius: 6px;
      .page-title {
        font-size: 30px;
        color: #646464;
        padding: 33px 0;
      }
      .operate-success-img {
        display: inline-block;
        height: 144px;
      }
      
      .operate-success-p {
        color: #00827A;
        font-size: 22px;
        margin-top: 10px;
      }
      .operate-success-p1 {
        color: #8B8B8B;
        font-size: 14px;
        margin-top: 20px;
        margin-bottom: 40px;
      }
      
      .margin-t-60 {
        margin-top: 60px;
      }
      .bottom-btns {
        text-align: left;
        padding-left: 502px;
      }
      .bottom-btns-1 {
        text-align: center;
        padding-left: 0;
      }
    }
  }
}
.fixed-btns{
  position: fixed;
  right: 20px;
  bottom: 60px;
  z-index: 10;
  .fixed-btn-item {
    width: 50px;
    height: 50px;
    background:#fff;
    box-shadow: 0px 2px 8px 2px rgba(203,203,203,0.5);
    border-radius: 2px;
    margin-bottom: 10px;
    text-align: center;
    cursor: pointer;
    position: relative;
    transition: opacity 0.5s;
    .iconfont {
      display: inline-block;
      font-size: 24px;
      color: #96C8B1;
      line-height: 50px;
    }
    .btn-hover {
      opacity: 0;
      display: inline-block;
      width: 100%;
      height: 100%;
      text-align: center;
      padding: 10px;
      line-height: 16px;
      color: @color-main;
      background: #fff;
      border-radius: 2px;
      position: absolute;
      top: 0;
      left: 0;
      transition: all 0.3s;
    }
    &:hover {
      .btn-hover {
        background: #C3ECE8;
        opacity: 1;
        transition: all 0.5s;
      }
    }
    &.last-item {
      opacity: 0;
    }
  }
  .fixed-btn-popover {
    margin: 10px 0;
  }
  .last-item-show {
    opacity: 1 !important;
    transition: opacity 0.5s;
  }
}
.self-popover-1 {
  padding: 14px;
  font-size: 16px;
  color: @color-main;
  .el-popover__title {
    line-height: 22px;
    margin-bottom: 4px;
    color: #515151;
  }
}
.self-popover-2 {
  width: 180px;
  height: 190px;
  padding: 10px 0;
  .self-popover-2-content {
    text-align: center;
    .wx-mini-img {
      width: 152px;
      height: 152px;
    }
    p {
      color: #454545;
    }
  }
}
</style>
